import axios from 'axios';
import qs from 'qs';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

/**
 * Complete the Denwa UC Nano setup
 *
 * @param {Object} configuration - Object containing the configuration
 * @returns {JSON} The result of the setup
 */
export const completeSetupService = configuration => axios({
    method: 'post',
    url: `${baseURL}/dws/setupapi/setup`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-access-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        configuration: JSON.stringify(configuration),
        api_key: 'setup_manager'
    })
});

/**
 * Resend verification code to a new destination
 *
 * @param {string} email - Verification code destination
 * @returns {JSON} The result of the operation
 */
export const resendVerificationCodeService = email => axios({
    method: 'put',
    url: `${baseURL}/dws/setupapi/license`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-access-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        email,
        api_key: 'setup_manager'
    })
});

/**
 * Activate Denwa Nano
 *
 * @param {number} code - Activation code
 * @returns {JSON} The result of the operation
 */
export const activateDenwaNanoService = code => axios({
    method: 'post',
    url: `${baseURL}/dws/setupapi/license`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-access-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        code,
        LAN: 'F8:51:6D:01:AA:05',
        WAN: 'F8:51:6D:01:AA:04',
        api_key: 'setup_manager'
    })
});
